import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Group, Tooltip } from '@mantine/core'
import GoogleIcon from '@legacy/common/Icons/Google'
import { IconProfile } from 'components/Icons'
import { useCurrentUser } from 'context/useCurrentUser'
import { useFeatureToggle } from 'hooks'
import { paths } from '../paths'
import {
  DropdownMenuSeparatorStyled,
} from '../NavbarMenuStyled'

import {
  NameStyled,
  SchoolNameStyled,
  DropdownMenuItemStyled,
  LinkStyled,
  NameContainerStyled,
} from './ProfileMenuStyled'

const ArcProfileMenu = () => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const schoolName = currentUser?.selected_school?.name
  const email = currentUser?.email || currentUser?.username
  const isGoogleConnected = Boolean(currentUser?.google_refresh_token)

  return (
    <>
      <DropdownMenuItemStyled style={{ paddingLeft: 20 }}>
        <NameContainerStyled style={{ paddingLeft: 0 }}>
          <NameStyled>{currentUser?.full_name}</NameStyled>
          <Group spacing={4}>
            {email && <SchoolNameStyled>{email}</SchoolNameStyled>}
            {isGoogleConnected && (
              <Tooltip label='Google connected' withArrow>
                <span style={{ marginLeft: 4, display: 'inline-flex' }}><GoogleIcon /></span>
              </Tooltip>
            )}
          </Group>
        </NameContainerStyled>
      </DropdownMenuItemStyled>
      <DropdownMenuSeparatorStyled />
      {schoolName && (
        <DropdownMenuItemStyled style={{ paddingLeft: 20, paddingTop: 4 }}>
          <NameContainerStyled style={{ paddingLeft: 0 }}>
            <SchoolNameStyled>{t('school')}</SchoolNameStyled>
            <NameStyled style={{ whiteSpace: 'normal' }}>{schoolName}</NameStyled>
          </NameContainerStyled>
        </DropdownMenuItemStyled>
      )}
      <DropdownMenuSeparatorStyled />
      <DropdownMenuItemStyled style={{ paddingLeft: 20 }}>
        <LinkStyled as={Link} to='/app/profile'>
          <IconProfile />
          <span style={{ marginLeft: 8 }}>{t('general_profiles_my')}</span>
        </LinkStyled>
      </DropdownMenuItemStyled>
      <DropdownMenuSeparatorStyled />
    </>
  )
}

export const ProfileMenu = () => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const isArcMosaico = useFeatureToggle('arc-mosaico-project') as boolean

  if (isArcMosaico) return <ArcProfileMenu />

  return (
    <>
      <DropdownMenuItemStyled>
        <IconProfile />
        <NameContainerStyled>
          <NameStyled>{currentUser?.full_name}</NameStyled>
          <LinkStyled href={paths.account.myProfile(currentUser?.profile_url || '')}>
            {t('general_profiles_my')}
          </LinkStyled>
        </NameContainerStyled>
      </DropdownMenuItemStyled>
      <DropdownMenuSeparatorStyled />
    </>
  )
}
